import AWS from "aws-sdk";
import dayjs from "dayjs";

const accessKey = process.env.REACT_APP_AWS_ACCESSKEY_ID;
const accessSecret = process.env.REACT_APP_AWS_ACCESSKEY_SECRET;
const region = process.env.REACT_APP_AWS_REGION;
const bucketName = process.env.REACT_APP_AWS_BUCKET_NAME;

const s3 = new AWS.S3({
  accessKeyId: accessKey,
  secretAccessKey: accessSecret,
  region: region,
});

const s3Controller = {
  s3Upload: (fileContent, path, callback) => {
    // const file = fileContent.name.split(".")
    const params = {
      Bucket: bucketName,
      Key: path + "/" + fileContent.name, // 폴더가 없으면 만들어서 넣는다.
      Body: fileContent,
    //   ContentType: fileContent.type
    };
    s3.upload(params, callback);
  },
  s3Upload2: (fileContent,name, callback) => {
    // const file = fileContent.name.split(".")
    const params = {
      Bucket: bucketName,
      Key: name, // 폴더가 없으면 만들어서 넣는다.
      Body: fileContent,
    //   ContentType: fileContent.type
    };
    s3.upload(params, callback);
  },
  s3Download: (prefix, fileName, callback) => {
    // const file = fileContent.name.split(".")
    const params = {
      Bucket: bucketName,
      Key: prefix + "/" + fileName
    };

    s3.getObject(params, callback);
  },
  s3List: (prefix, callback) => {
    const params = {
      Bucket: bucketName,
      Prefix: prefix,
    }
    s3.listObjects(params, callback)
  },
  s3DeleteFile: (key,callback) => {
    const params = {
      Bucket: bucketName,
      Key: key,
    }
    s3.deleteObject(params, callback)
  },
  s3DeleteFiles: (objects,callback) => {
    const params = {
      Bucket: bucketName,
      Delete: {
        Objects:objects
      }
    }
    s3.deleteObjects(params, callback)
  },
};

export default s3Controller;
